import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useState } from "react";

interface FormFieldDynamicProps {
  field: {
    id: string;
    name: string;
    label: string;
    type: 'text' | 'email' | 'tel';
    required: boolean;
    placeholder: string;
  };
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export function FormFieldDynamic({ field, value, onChange, error }: FormFieldDynamicProps) {
  const [touched, setTouched] = useState(false);

  const handleBlur = () => {
    setTouched(true);
  };

  const formatWhatsApp = (val: string) => {
    // Remove tudo exceto números
    const numbers = val.replace(/\D/g, '');
    
    // Aplica máscara (XX) XXXXX-XXXX
    if (numbers.length <= 2) return `(${numbers}`;
    if (numbers.length <= 7) return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;
    
    if (field.type === 'tel' && field.name === 'whatsapp') {
      newValue = formatWhatsApp(newValue);
    }
    
    onChange(newValue);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor={field.id}>
        {field.label}
        {field.required && <span className="text-destructive ml-1">*</span>}
      </Label>
      <Input
        id={field.id}
        name={field.name}
        type={field.type === 'tel' ? 'tel' : field.type}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={field.placeholder}
        required={field.required}
        className={error && touched ? 'border-destructive' : ''}
      />
      {error && touched && (
        <p className="text-xs text-destructive">{error}</p>
      )}
    </div>
  );
}
